import { openEnvironmentFileByPath } from "@/lib/environment-files";

/** 差分の対象ファイル名。押すとエディタで開く。 */
export function DiffFileLink({
	path,
	wrap = false,
}: {
	path: string;
	/** 1 行に切らず折り返して全体を出す。 */
	wrap?: boolean;
}) {
	return (
		<button
			type="button"
			title={wrap ? undefined : path}
			data-tooltip-if-truncated={wrap ? undefined : true}
			data-tooltip-nowrap={wrap ? undefined : true}
			onClick={() => {
				openEnvironmentFileByPath(path).catch((err: unknown) => {
					console.error("ファイルを開けませんでした", err);
				});
			}}
			className={`min-w-0 ${wrap ? "break-all" : "truncate"} cursor-pointer border-0 bg-transparent p-0 text-left font-mono text-caption text-fg-2 hover:text-fg-1 hover:underline hover:decoration-fg-3 hover:underline-offset-2`}
		>
			{path}
		</button>
	);
}
